


























import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { OwnBankInfoResourceModel } from '@/modules/bank-account/models/bank-account-resource.model'

@Component
export default class PaymentBankInfo extends Vue {
  @Prop() bankInfo !: OwnBankInfoResourceModel
}
